import {ChangeDetectorRef, Component} from '@angular/core';
import {
    AlertController, App, IonicPage, LoadingController, MenuController, ModalController, NavController, NavParams,
    Platform,
    ToastController, ViewController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import { Storage } from '@ionic/storage';
import {ListDataModelPage} from "../list-data-model/list-data-model";


@Component({
  selector: 'page-enquiry-form',
  templateUrl: 'enquiry-form.html',
})
export class EnquiryFormPage {

    UserName:any;
    FUserId:any;
    FUserTypeId:any;
    Name:any;
    StandardData:any;
    Standard:any;
    Mobile1:any;
    Mobile2:any;
    SourceData:any;
    Source:any;
    SchoolData:any;
    School:any;
    Comment:any;
    GuestData:any;
    FGuestId:any;
    EditData:any;
    isEnabled=false;
    FWebEnquiryId:any;
    UseSource:any;
    SiblingsData:any;
    Siblings=0;
    CommonId:any;
    IsAppointment:any;
    IsJustDialData:any;




  constructor(public navCtrl: NavController, public navParams: NavParams, public service: ServiceProvider, public platform:Platform, menuCtrl:MenuController, public loadingCtrl: LoadingController, public toastCtrl: ToastController,
              public storage: Storage,
              public _app: App,
              public modalCtrl: ModalController,
              public alertCtrl: AlertController,
              public cdRef:ChangeDetectorRef,
              public viewCtrl: ViewController) {
    this.platform.ready().then(() => {
        this.isEnabled=false;
      Promise.all([this.storage.get('LoginData'),this.storage.get('UserData')]).then(values => {
          console.log("213",values);
          this.UserName=values[1]['Name'];
        this.FUserId = values[0]['FUserId'];
          this.FUserTypeId = values[0]['FUserTypeId'];
        console.log(this.FUserId);

          // this.IsJustDialData = navParams.get('Jd');
          // if(this.IsJustDialData==12){
          //     this.Source=this.IsJustDialData;
          //     this.isEnabled=true;
          // }

          console.log("navParams->",navParams);

        this.GuestData = navParams.get('dataPlus');

        if(this.GuestData){
            this.Mobile1 = this.GuestData.MobileNumber;
            this.Name=this.GuestData.Name;
            this.Source = this.GuestData.SourceId;
            this.School = this.GuestData.FSchoolId;
            this.FGuestId=this.GuestData.Id;
            if(this.GuestData.SourceId){
                this.isEnabled=true;
            }
        }

        this.EditData=navParams.get('editData');

        if(this.EditData){
            console.log("IsAppointment"+navParams.get('IsAppointment'));
            this.IsAppointment=navParams.get('IsAppointment');
            if(this.IsAppointment==0){
                this.FWebEnquiryId=this.EditData.Id;
                console.log("this.FWebEnquiryId->",this.FWebEnquiryId);
                this.Name=this.EditData.StudentName;
                this.Standard=this.EditData.StandardId;
                this.Mobile1=this.EditData.Phone1;
                this.Mobile2=this.EditData.Phone2;
                this.Source=this.EditData.FEnquirySourceId;
                this.School=this.EditData.SchoolId;
                this.Comment=this.EditData.Comment_;
                if(this.EditData.FEnquirySourceId){
                    this.isEnabled=true;
                    this.UseSource=true;
                }
            }
            else if(this.IsAppointment==1){
                this.FWebEnquiryId=this.EditData.FWebEnquiryId;
                this.Mobile1=this.EditData.Phone1;
                this.Mobile2=this.EditData.Phone2;
                this.School=this.EditData.FSchoolId;
                this.Comment=this.EditData.Comment;
                this.Source=this.EditData.FEnquirySourceId;
                this.Standard=this.EditData.FStandardId;
                this.Name=this.EditData.Name1;
                if(this.EditData.FEnquirySourceId){
                    this.isEnabled=true;
                    this.UseSource=true;
                }
            }
            console.log("EditData",this.EditData);
        }

          this.EditData=navParams.get('editDataCalls');
          if(this.EditData){
              console.log("IsAppointment"+navParams.get('IsAppointment'));
              this.IsAppointment=navParams.get('IsAppointment');
              if(this.IsAppointment==0){
                  this.FWebEnquiryId=this.EditData.FWebEnquiryId;
                  this.Name=this.EditData.StudentName;
                  this.Standard=this.EditData.Standard;
                  this.Mobile1=this.EditData.PhoneNumber1;
                  this.Mobile2=this.EditData.PhoneNumber2;
                  this.Source=this.EditData.FEnquirySourceId;
                  this.School=this.EditData.SchoolId;
                  this.Comment=this.EditData.Comment;
                  if(this.EditData.FEnquirySourceId){
                      this.isEnabled=true;
                      this.UseSource=true;
                  }
              }
              console.log("EditData",this.EditData);

          }

          this.SiblingsData = navParams.get('SiblingsData');
          this.Siblings = navParams.get('Siblings');
          if (this.Siblings == 1) {
              console.log("SiblingsData");
              this.Name = this.SiblingsData.StudentName;
              this.Standard = this.SiblingsData.StandardId;
              this.Mobile1 = this.SiblingsData.Phone1;
              this.Mobile2 = this.SiblingsData.Phone2;
              this.Source = this.SiblingsData.FEnquirySourceId;
              this.School = this.SiblingsData.SchoolId;
              if (this.SiblingsData.CommonId) {
                  this.CommonId = this.SiblingsData.CommonId;
              } else {
                  this.CommonId = this.SiblingsData.Id;
              }

              if (this.SiblingsData.FEnquirySourceId) {
                  this.isEnabled = true;
                  this.UseSource = true;
              }
          }

          this.SiblingsData = navParams.get('SiblingsDataCalls');
          if(this.SiblingsData){
              this.Siblings = navParams.get('SiblingsCalls');
              if (this.Siblings == 1) {

                  console.log("SiblingsDataCalls");
                  this.Name = this.SiblingsData.StudentName;
                  this.Standard = this.SiblingsData.Standard;
                  this.Mobile1 = this.SiblingsData.PhoneNumber1;
                  this.Mobile2 = this.SiblingsData.PhoneNumber2;
                  this.Source = this.SiblingsData.FEnquirySourceId;
                  this.School = this.SiblingsData.SchoolId;
                  if (this.SiblingsData.CommonId) {
                      this.CommonId = this.SiblingsData.CommonId;
                  } else {
                      this.CommonId = this.SiblingsData.FWebEnquiryId;
                  }

                  if (this.SiblingsData.FEnquirySourceId) {
                      this.isEnabled = true;
                      this.UseSource = true;
                  }
              }
          }


        this.loadStandard();
        this.loadSource();
        this.loadSchool();
      });
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EnquiryFormPage');
  }
  dismiss() {
    this.viewCtrl.dismiss(0);
  }
  loadStandard(){
    this.service.httpcall('web_service/get_standard?').subscribe(data => {
      console.log(data);
      this.StandardData=data;
    })
  }
  loadSource(){
      let url;
      if(this.UseSource==true){
          url='web_service/get_enquiry_source?';
      }else{
          url='web_service/get_enquiry_source?params[Use]=1';
      }
    this.service.httpcall(url).subscribe(data => {
      console.log(data);
      this.SourceData=data;
    })
  }
  loadSchool(){
    this.service.httpcall('web_service/get_school?').subscribe(data => {
      console.log(data);
      this.SchoolData=data['data'];
    })
  }

  submit_form(){
    if(this.Name==null || this.Name==""){
      this.presentToast("Name Required!");
    }else if(this.Standard==null || this.Standard==""){
      this.presentToast("Standard Required!");
    }else if(this.Mobile1==null || this.Mobile1==""){
      this.presentToast("Mobile1 Required!");
    }else if(this.Mobile1.toString().length > 10|| this.Mobile1.toString().length < 10){
        this.presentToast("Mobile1 number must 10 digit Required!");
    }else if(this.Source==null || this.Source==""){
      this.presentToast("Source Required!");
    }else if(this.School==null || this.School==""){
      this.presentToast("School Required!");
    }else{
        var json_obj = {};
        json_obj['CreatedBy'] = this.FUserId;
        json_obj['Name'] = this.Name;
        json_obj['UserName'] = this.UserName;
        json_obj['Phone1'] = this.Mobile1;
        json_obj['Phone2'] = this.Mobile2;
        json_obj['Standard'] = this.Standard;
        json_obj['SchoolId'] = this.School;
        json_obj['Comment'] = this.Comment;
        json_obj['FUserType'] = this.FUserTypeId;
        json_obj['FEnquirySourceId']=this.Source;
        json_obj['IsAppointment'] = this.IsAppointment;
        let url;

        if(this.FGuestId){
            json_obj['FGuestId']= this.FGuestId;
        }

        if(this.Siblings==1 ){
            json_obj['Siblings']= this.Siblings;
            json_obj['CommonId']=this.CommonId;
        }

        if(this.FWebEnquiryId){
            console.log("this.FWebEnquiryId_->",this.FWebEnquiryId);
            json_obj['FWebEnquiryId']= this.FWebEnquiryId;
            url='web_service/update_web_enquiry_by_school_id';
        }else{
            url='web_service/submit_web_enquiry_by_school_id';
        }


        console.log(json_obj);

        let loading = this.loadingCtrl.create({
            content: 'loading'
        });

        loading.present();


        this.service.httppostcall(url, json_obj).subscribe(data => {
            console.log(data);
            if(loading)
                loading.dismiss();
            loading = undefined;
            if (data['response'] == 'success') {
                //  this.presentToast(data['success_message']);
                this.Name=null;
                this.StandardData=null;
                this.Standard=null;
                this.Mobile1=null;
                this.Mobile2=null;
                this.SourceData=null;
                this.Source=null;
                this.SchoolData=null;
                this.School=null;
                this.Comment=null;
                this.isEnabled=false;
                this.viewCtrl.dismiss(data['success_message']);
            } else {
                this.presentToast(data['error_description']);
                if(data['data']){
                    let ListModel = this.modalCtrl.create(ListDataModelPage,{data:data['data'],title:data['error_description']});
                    ListModel .onDidDismiss(data => {
                        console.log(data);
                        this.presentToast(data);
                    });
                    ListModel.present();
                    /*const alert = this.alertCtrl.create({
                        title: data['error_description'],
                        buttons: ['OK']
                    });

                    for(var i = 0; i < data['data'].length; i++) {
                        this.emp=data['data'][i];
                        var edata="Name: "+this.emp.Name+" - Source:"+this.emp.SourceName;
                        alert.addInput({
                            type:'radio',
                            label: edata,
                            value: this.emp.Id
                        })
                    }

                    alert.present();*/
                }
            }
        },(err)=>{
            loading.dismiss();
            console.log(json_obj);
            this.presentToast("TimeOut!");
        });
    }

  }

  presentToast(msg){
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/enquiry-form/enquiry-form.ts